import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries, devConfig, profile } from 'config/config'; // Importing configuration variables

/**
 * Class representing the FilterPartnersProductsView.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            labelPosition: 'top',
                            label: _('Descripción'), // Label for description input
                            placeholder: _('Descripción'), // Placeholder for description input
                            name: 'Description', // Name of the input field
                        },
                        {
                            view: 'text',
                            labelPosition: 'top',
                            label: _('Slug'), // Label for slug input
                            placeholder: _('Slug'), // Placeholder for slug input
                            name: 'Slug', // Name of the input field
                        },
                        {
                            view: 'richselect',
                            name: 'State', // Name of the state select
                            label: _('Estado'), // Label for state select
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for state select
                            options: [
                                { id: '0', value: _('Activa') }, // Active state option
                                { id: '1', value: _('Inactiva') }, // Inactive state option
                            ],
                        },
                        {
                            view: 'combo',
                            labelPosition: 'top',
                            label: _('Tipo'), // Label for type combo
                            placeholder: _('Click para seleccionar '), // Placeholder for type combo
                            name: 'Type', // Name of the input field
                            options: [
                                { id: '0', value: _('Casino') }, // Casino type option
                                { id: '1', value: _('Live Casino') }, // Live Casino type option
                                { id: '2', value: _('Virtuales') }, // Virtual type option
                                { id: '3', value: _('Mini Games') }, // Mini Games type option
                            ],
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Responsive height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };

        // Button section with action buttons
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 }, // Gravity for layout adjustment
                        {
                            view: 'button',
                            value: _('Agregar'), // Add button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('add:button', [{}]); // Event call for adding
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues(
                                    $$('myForm').getCleanValues(), // Reset form values
                                );
                                $$('CountrySelect').setValue(
                                    $$('myForm').getCleanValues().CountrySelect, // Reset country select value
                                );
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            value: _('Consultar'), // Consult button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values for filtering
                                this.app.callEvent('partnerCategories:filter', [
                                    filterdata, // Event call for filtering
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main form configuration
        return {
            view: 'form',
            id: 'myForm', // ID for the form
            type: 'clean',
            rows: [accordion_section1], // Including the accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {}
}

// FILE DOCUMENTED
